import HomeV1 from './v1';
import HomeV2 from './v2';

// Default export - new modern version
export default HomeV2;

// Named exports for specific versions
export { HomeV1, HomeV2 };